export enum ModalType {
  PIN = 'pin',
  WARNING = 'warning',
  DETECTED_ERRORS = 'detected_errors',
  SUCCESS = 'success',
  EDIT_PARAMETERS = 'edit_parameters',
  BASIC = 'basic',
  CHANGE_PASSWORD = 'change_password',
  PRODUCT_PREVIEW = 'product_preview',
  REMOVE_COMPANY = 'remove_company',
  AUTO_ASSIGN = 'auto_assign',
}

export interface Modal {
  id?: string;
  title: string;
  subtitle?: string;
  body?: string;
  data?: unknown;
  modalType: ModalType;
  loadingAction?: string;
  onBackdropClose?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryAction?: () => void;
  secondaryAction?: () => void;
  icon?: string;
  className?: string;
}
